import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { Files } from 'components/misc'
import styles from './assessor-participant-rp-activity.styl'

export default class AssessorRPParticipantActivity extends Component {
  static propTypes = {
    eventParticipants: PropTypes.object,
    assessment: PropTypes.object
  }

  render() {
    const { eventParticipants, assessment } = this.props

    return (
      <div className="base-margin--top">
        <p className={styles.paragraph}>
          <span className={styles.bold}>
            <FormattedMessage id="label.goal" defaultMessage="Goal" />:{' '}
          </span>
          {get(eventParticipants, 'goal')}
        </p>
        <p className={styles.paragraph}>
          <span className={styles.bold}>
            <FormattedMessage
              id="label.project_location_type"
              defaultMessage="Project location type"
            />
            :{' '}
          </span>
          {get(eventParticipants, 'projectLocationType.translationText')}
        </p>
        <p className={styles.paragraph}>
          <span className={styles.bold}>
            <FormattedMessage
              id="label.location_detail"
              defaultMessage="Location detail"
            />
            :{' '}
          </span>
          {get(eventParticipants, 'locationDetail')}
        </p>
        <p className={styles.paragraph}>
          <span className={styles.bold}>
            <FormattedMessage
              id="label.observations"
              defaultMessage="Observations"
            />
            :{' '}
          </span>
          {get(eventParticipants, 'observations')}
        </p>
        {get(eventParticipants, 'fileUrls.length') > 0 &&
          <Files urls={eventParticipants.fileUrls} decoWithCode decoWithCodeFromUrl />}

        <p className={styles.paragraph}>
          <span className={styles.bold}>
            <FormattedMessage id="label.note" defaultMessage="Note" />:{' '}
          </span>
          {get(assessment, 'data.note')}
        </p>
      </div>
    )
  }
}
